import { TutorialScreen } from '../lib/tutorial';
import { TutorialBubble, TutorialOverlay } from './game.styles';

const getTutorialText = (screen: TutorialScreen) => {
  switch (screen) {
    case 1:
      return (
        <>
          <p>This is Drop7!</p>
          <p>Score as many points as you can before the grid overflows.</p>
        </>
      );
    case 2:
      return (
        <p>
          Earn points by matching the number on a disc to the amount
          of discs in its row or column.
        </p>
      );
    case 3:
      return (
        <p>Drop the 5 into the center column.</p>
      );
    case 4:
      return (
        <p>
          Did you see that? The 5 exploded because the column had five
          discs in it!
        </p>
      );
    case 5:
      return (
        <p>Tap to drop the 2 into the first column.</p>
      );
    case 6:
      return (
        <p>
          Nice match! The 2 exploded because there were two connected
          discs in its row.
        </p>
      );
    case 7:
      return (
        <p>
          These are solid discs. You gotta crack them twice to reveal
          a numbered disc.
        </p>
      );
    case 8:
      return (
        <p>A solid disc will crack when a disc explodes next to it.</p>
      );
    case 9:
      return (
        <p>Drop the 4 into a row of four discs to crack a few solid discs.</p>
      );
    case 10:
      return (
        <p>
          Now drop the 2 into a column of two discs to crack the solid
          discs again!
        </p>
      );
    case 11:
      return (
        <p>
          Sometimes after you make a match, the discs will fall and create
          another match. That’s a Chain Combo!
        </p>
      );
    case 12:
      return (
        <p>Drop the 3 here to start a Chain Combo.</p>
      );
    case 13:
      return (
        <p>Nice one! The longer your Chain Combo, the more points you get!</p>
      );
    case 14:
      return (
        <>
          <p>
            And remember, each time you level up, a new row of solid discs will
            push up from the bottom.
          </p>
          <p>Now let’s DROP!</p>
        </>
      );
    default:
      return '';
  }
};

type TutorialOverlayProps = {
  screen: TutorialScreen;
  visible: boolean;
  advance?: () => void;
};

export default function Tutorial({ screen, visible, advance }: TutorialOverlayProps) {
  return (
    <>
      {advance && <TutorialOverlay onClick={advance} />}
      <TutorialBubble visible={visible}>{getTutorialText(screen)}</TutorialBubble>
    </>
  );
}
